import AccordionList from '@/common/components/accordion-list';
import { withPageContainerStyles } from '@/common/components/page-layout';
import Spacer from '@/common/components/spacer';

const faqs = [
  {
    title: "$0 down, cancel anytime, cheaper than leasing or buying - what's the catch?",
    content: [
      {
        body: (
          <p className="subhead-tight font-[400] text-flexcar-neutral1">
            There is no catch!
            <br /> <br />
            We ditched the traditional dealership model which has extra costs baked in. No
            fancy showrooms, no pushy salespeople, and no hidden fees. We&apos;re about
            efficiency and savings. That&apos;s it. We get the best deals on cars,
            insurance, and service costs. You can reap the benefits all from the
            convenience of the Flexcar app. You get to skip the hassle of the dealership
            and save money while you&apos;re at it.
            <br /> <br />
            So yeah - zero down, lower monthly payments, and you can cancel anytime.
          </p>
        ),
      },
    ],
  },
  {
    title: 'How is Flexcar different from a traditional lease?',
    content: [
      {
        body: (
          <>
            <p className="subhead-tight text-flexcar-neutral1">
              Can traditional leases do this?
            </p>
            <Spacer variant="height16" />
            <ul className="subhead-tight text-flexcar-neutral1">
              <li>$0 down</li>
              <li>No dealership fees that take the air out of your tires</li>
              <li>Cancel anytime with no awkward goodbyes</li>
              <li>
                Keep the car as long as you want or swap it out like a wardrobe change
              </li>
              <li>Insurance? Check. Roadside assistance? Check. Peace of mind? Check</li>
            </ul>
          </>
        ),
      },
    ],
  },
  {
    title: 'How can Flexcar help me avoid the sneaky hidden dealership fees?',
    content: [
      {
        body: (
          <p className="subhead-tight text-flexcar-neutral1">
            No fees you can&apos;t see.
            <br />
            <br />
            Honesty is our policy. Dealerships make money by charging you for fees with a
            side of car. By the time they&apos;re done with documentation fees, VIN
            etching, financing fees and destination fees, you are left wondering if
            you&apos;re going to get a bill for using the toilet.
            <br />
            <br />
            With Flexcar, we spare you from the dread of dealership debt and make it clear
            what you&apos;re paying for at all times
          </p>
        ),
      },
    ],
  },
  {
    title: "What's included with my Flexcar?",
    content: [
      {
        body: (
          <p className="subhead-tight text-flexcar-neutral1">
            Everything you need. Nothing you don&apos;t
            <br />
            <br /> We slip money in your pocket like your favorite grandparent.
            Maintenance, insurance and 24/7 roadside assistance is all included. We even
            help you save on gas at the pump when you fill up at Sunoco. Flexcar is your
            one-stop shop for all your car&apos;s needs.
          </p>
        ),
      },
    ],
  },
  {
    title: 'Is there really no down payment?',
    content: [
      {
        body: (
          <p className="subhead-tight text-flexcar-neutral1">
            Zero&apos;s across the board.
            <br />
            <br />
            $0 down. Zero hassle. Zero B.S. Unlike that non-refundable down payment that
            goes up in flames at the dealership, Flexcar charges you nothing upfront. We
            only ask for a refundable security deposit in rare cases. If you keep your car
            in good shape, drive like a responsible human and don&apos;t take your Flexcar
            off-roading, that deposit is all yours when you return the car.
          </p>
        ),
      },
    ],
  },
  {
    title: 'Can I cancel anytime?',
    content: [
      {
        body: (
          <p className="subhead-tight text-flexcar-neutral1">
            Absolutely! With Flexcar, there are no long-term contracts—just month-to-month
            flexibility. We aim to be the only car you&apos;ll ever need, but we get
            it—life happens. If you need to cancel or make a change, no worries.
            We&apos;re here to make it easy and support you along the way.
          </p>
        ),
      },
    ],
  },
  {
    title: 'Can I swap cars anytime?',
    content: [
      {
        body: (
          <p className="subhead-tight text-flexcar-neutral1">
            Yes, imagine having a four-car garage at your fingertips. With Flexcar, you
            can drive what you want, when you want. Cruise through summer with the top
            down in a Jeep Wrangler or conquer winter terrain in a rugged Toyota Tacoma.
            For a small swap fee, you can switch to the perfect car for every season and
            every adventure. Stay flexible—drive your way.
          </p>
        ),
      },
    ],
  },
  {
    title: 'Is maintenance covered by Flexcar?',
    content: [
      {
        body: (
          <p className="subhead-tight text-flexcar-neutral1">
            We&apos;ve got you covered from bumper to bumper.
            <br />
            <br />
            You can let off the gas with Flexcar. We take care of all your routine
            maintenance. No more scraping under the driver&apos;s seat to pay those
            unexpected repair bills. Keep cruising and leave the costs to us. Siri, play
            &quot;Three Little Birds&quot; by Bob Marley.
          </p>
        ),
      },
    ],
  },
  {
    title: "How do I know if I'm eligible?",
    content: [
      {
        body: (
          <>
            <p className="subhead-tight text-flexcar-neutral1">
              To drive a Flexcar, you need the following:
            </p>
            <Spacer variant="height16" />
            <ul className="subhead-tight text-flexcar-neutral1">
              <li>21+ years old</li>
              <li>Valid US or US Territory driver&apos;s license</li>
              <li>Verified email address</li>
              <li>Consent for a soft credit check.</li>
              <li>This won&apos;t affect your credit score</li>
            </ul>
          </>
        ),
      },
    ],
  },
];

export default function QuestionsAnswers() {
  return (
    <div className="flex w-full flex-row justify-center bg-flexcar-neutral100">
      <div
        className={withPageContainerStyles(
          'max-w-[1024px] px-[24px] py-[88px] md:px-[64px] md:py-[120px]'
        )}
      >
        <h3 className="header-sans-tight text-center text-flexcar-neutral1">
          You&apos;ve got questions.
          <br />
          We&apos;ve got answers.
        </h3>
        <Spacer variant="height56" />

        <AccordionList
          accordionItems={faqs}
          variant="default"
          separateItemsWithHorizontalRule
        />
      </div>
    </div>
  );
}
